<template>
  <div>
    <div class="form-group">
      <label for="rue">
        Rue
      </label>
      <input
        id="rue"
        v-model="street"
        type="text"
        class="form-control"
        :class="streetValidation"
        placeholder="15 rue Poissonnière"
      >
    </div>
    <div class="form-group">
      <label for="codepostal">
        Code Postal
      </label>
      <input
        id="codepostal"
        v-model="postalCode"
        type="text"
        class="form-control"
        :class="postalCodeValidation"
        placeholder="75002"
      >
    </div>
    <div class="form-group">
      <label for="ville">
        Ville
      </label>
      <input
        id="ville"
        v-model="city"
        type="text"
        class="form-control"
        :class="cityValidation"
        placeholder="Paris"
      >
    </div>
    <div class="form-group">
      <label for="pays">
        Pays
      </label>
      <input
        id="pays"
        v-model="country"
        type="text"
        class="form-control"
        :class="countryValidation"
        placeholder="France"
      >
    </div>
  </div>
</template>
<script>
import { isEmpty, get } from 'lodash-es';
import { mapGetters } from 'vuex';

export default {
  name: 'InputAddress',
  props: {
    actionName: {
      type: String,
      required: true,
      default: () => 'setValueWithPath',
    },
    actionModule: {
      type: String,
      required: true,
      default: () => 'company',
    },
    path: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {
      validAddress: false,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company/get',
    }),
    address() {
      return get(get(this.$store.state, this.actionModule), this.path);
    },
    isCreated() {
      return !isEmpty(this.company.id);
    },
    countryValidation() {
      return isEmpty(this.country) ? '' : '';
    },
    cityValidation() {
      return isEmpty(this.city) ? '' : '';
    },
    streetValidation() {
      return isEmpty(this.street) ? '' : '';
    },
    postalCodeValidation() {
      return isEmpty(this.postalCode) ? '' : '';
    },
    country: {
      get() { return this.address.country; },
      set(value) { this.setAddress(value, 'country'); },
    },
    city: {
      get() { return this.address.city; },
      set(value) { this.setAddress(value, 'city'); },
    },
    street: {
      get() { return this.address.street; },
      set(value) { this.setAddress(value, 'street'); },
    },
    postalCode: {
      get() { return this.address.postalCode; },
      set(value) { this.setAddress(value, 'postalCode'); },
    },
  },
  mounted() {
    this.$emit('is-address-valid', this.isValid);
  },
  methods: {
    setAddress(value, key) {
      this.$store.dispatch(`${this.actionModule}/${this.actionName}`,
        { value, path: `${this.path}.${key}` });
    },
  },
};
</script>
<style scoped>
button:focus{
  outline: none;
}
input::placeholder {
  color:rgb(175, 175, 175);
}
.angle {
  right: 23px;
  font-size: 12px;
  top: 10px;
}
#research:focus {
  outline: 0;
  box-shadow: none;
}
</style>
